import React from 'react';
import { NumberInput, DropdownSelector } from 'hyperdb-utils';

const GlobalSettings = ({ vatPercent, currency, onChange }) => {
  const handleChange = (attributeName, { value} ) => onChange(attributeName, value);
  return (
    <fieldset>
      <NumberInput
        label="Vat percent"
        value={ vatPercent }
        onChange={ handleChange.bind(null, 'vatPercent') }
      />
      <DropdownSelector
        label="Currency"
        value={ currency }
        onChange={ handleChange.bind(null, 'currency') }
        options={ ['EUR', 'USD'].map(o => ({ name: o, value: o})) }
      />
    </fieldset>
  );
};

export default GlobalSettings;



// WEBPACK FOOTER //
// ./src/frontend/init-wizard/GlobalSettings.jsx